/* eslint-disable import/no-internal-modules */
import ConfirmationModal from '@insided/deprecated-preact-components/modal/ConfirmationModal'

interface Props {
  isOpen: boolean
  onClose: () => void
  onToggleSpam: () => void
  selectedReplyId?: string
}

const MarkAsNotSpamModal = (
  { isOpen, onClose, onToggleSpam, selectedReplyId }: Props) => {
  const bodyText = `The ${selectedReplyId === undefined ? 'topic' : 'post'} will be visible again in community. This action will not unban the author automatically, please go to user profile page in control and change user role.`
  return (
    <ConfirmationModal
      title='Mark as not spam?'
      body={bodyText}
      action='Mark as not spam'
      variant='brand'
      isOpen={isOpen}
      onClose={onClose}
      handleConfirmation={onToggleSpam}
    />
  )
}

export default MarkAsNotSpamModal
